import { toast } from 'sonner';
import { useFileUpload } from '@/lib/upload/useFileUpload.ts';
import companyApi from '@/features/dashboard/company/api/companyApi.ts';

interface CompanyLogoUploadResult {
  fileId: string;
}

export default function useUploadCompanyLogo() {
  return useFileUpload<CompanyLogoUploadResult>({
    initUpload: async (request) => {
      return companyApi.initLogoUpload(request);
    },
    processUpload: async (fileId: string) => {
      await companyApi.confirmLogoUpload(fileId);
      return { fileId };
    },
    onError: (error: Error) => {
      toast.error('Błąd przesyłania', {
        description: error.message || 'Wystąpił błąd podczas przesyłania logo.',
      });
    },
  });
}
